module.exports = __webpack_public_path__ + "docs/oven-9ec332.md";